import {
  useCallback,
  useContext,
} from "react";
import PymblePage from "./PymblePage";
import CoversFileUploader from "../components/common/CoversFileUploader";
import SelectedContext from "../contexts/SelectedContext";
import { useTeacherAbsences } from "../hooks/useTeacherAbsences";

import "./Uploads.css";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface UploadsProps { }

const Uploads: React.FC<UploadsProps> = () => {

  const { selectedAbsenceDate, firstDate, lastDate } =
    useContext(SelectedContext);

  const {
    refreshTeacherAbsences,
    refreshAbsenceRange,
  } = useTeacherAbsences(selectedAbsenceDate);

  const handleUploadComplete = useCallback((data: any) => {
    console.log("Uploads: handleUploadComplete: ", data);
    refreshTeacherAbsences();
    refreshAbsenceRange(firstDate, lastDate);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstDate, lastDate]);


  return (
    <PymblePage cssClass="uploads-page">
      <h2>Upload Edval Files</h2>
      <CoversFileUploader settings={{ DataType: "edval-absences" }} showMessages={true} onUploadComplete={handleUploadComplete} />
    </PymblePage>
  );
};

export default Uploads;
